var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.componentElement,
    { tag: "component", class: _vm.classList, style: _vm.styleList },
    [
      _c("p", {
        staticClass: "badge__label",
        domProps: { innerHTML: _vm._s(_vm.label) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }